import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-label"]

import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";

type scrollTopButtonProps = {
	enabled: boolean;
}

type scrollTopButtonEmit = {
	"on-click": [];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppScrollTopButton',
  props: {
    enabled: { type: Boolean, default: false }
  },
  emits: ["on-click"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppTooltip, {
    class: "app-scroll-top-tooltip",
    text: _ctx.$t('ui_scroll_top'),
    disabled: !props.enabled
  }, {
    activator: _withCtx(() => [
      _createElementVNode("button", {
        class: _normalizeClass({
					'app-scroll-top': true,
					'app-scroll-top--enabled': props.enabled
				}),
        type: "button",
        "aria-label": _ctx.$t('ui_scroll_top'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('on-click')))
      }, [
        _createVNode(AppIcon, {
          name: "arrow-up",
          width: "24px",
          color: "#fff"
        })
      ], 10, _hoisted_1)
    ]),
    _: 1
  }, 8, ["text", "disabled"]))
}
}

})